import React, { useLayoutEffect } from "react";
import { ClincCardImage, EntiraClinicLogo, EntiraClinicVideo, TeleConnectEntiraLogo } from "../../../../../assets";
import VideoRenderer from "../../../../shared/videoRender/VideoRenderer";
import person1 from "../../../../../assets/Person1.jpg";
import person2 from "../../../../../assets/Person002.jpg";
import person3 from "../../../../../assets/Person003.jpg";
import person4 from "../../../../../assets/Person004.jpg";
import person5 from "../../../../../assets/Person005.jpg";
import person6 from "../../../../../assets/Person006.jpg";

import "./clinicCard.scss";

const ClinicCard: React.FC = (): JSX.Element => {
	const handleRedirectEntiraWebsite = () => {
		const path = "https://entiraclinic.com/";
		window.open(path);
	};

	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});

	return (
		<div>
			<div className="clinic-card-main-container">
				<div className="main-landing-container">
					<div className="left-section">
						<h3 className="main-benefits-title">Clinic Card Program</h3>
						<div className="powered-by-logo-container">
							<span>Powered By</span>
							<img src={EntiraClinicLogo} alt="" />
						</div>
						<div className="plan-description">
							<ul>
								<li>Patients must be 8 years or older</li>
								<li>Unlimited office visits</li>
								<li>$10 flat fee per visit</li>
								<li>
									{" "}
									FREE lab work to ALL patients (we have a contract with CPL labs who have tons of
									locations) o Personal provider call-backs regarding lab results
								</li>
								<li>
									{" "}
									TeleConnect Virtual Visits available to ALL patients – closing the distance to
									healthcare The physical clinic location is inside the Gaslight Brookshire Brothers
									(in Lufkin, TX) next to the pharmacy
								</li>
								<li>
									{" "}
									Pharmaceutical Advocacy Specialist on staff to assist patients with navigating the
									affordability of prescribed medications
								</li>
								<li> Same day appointments available</li>
								<button className="entira-redirection-button" onClick={handleRedirectEntiraWebsite}>
									Vist Entira&apos;s Website
								</button>
							</ul>
						</div>
					</div>
					<div className="right-section">
						<img src={ClincCardImage} alt="clinic card image" />
					</div>
				</div>

				<h3 className="sub-heading-title">Entira Featured</h3>
				<div className="feature-grid-renderer-section">
					<div className="video-container">
						<VideoRenderer videoSource={EntiraClinicVideo} />
					</div>
					<div className="entira-featured-card-health-plan">
						<img src={EntiraClinicLogo} alt="" />
						<span>
							Wonderful, convenient medical care! My family has been using the Entira Clinic for the past
							four years and we are extremely satisfied with the high-quality services they provide. And
							we love their team!
						</span>
					</div>
				</div>
			</div>

			<div className="entira-poster">
				<h1 className="entira-heading">We Focus on Your Health!</h1>
				<h2>Call Us for an Appointment Today!</h2>
			</div>

			<div className="services-main-container">
				<h1>OUR SERVICES</h1>
				<svg
					fill="#2bd44d"
					height="85px"
					width="95px"
					version="1.1"
					id="Layer_1"
					xmlns="http://www.w3.org/2000/svg"
					xmlnsXlink="http://www.w3.org/1999/xlink"
					viewBox="0 0 512.00 512.00"
					xmlSpace="preserve"
					stroke="#2bd44d"
					strokeWidth="0.00512"
				>
					<g id="SVGRepo_bgCarrier" strokeWidth={0} />
					<g
						id="SVGRepo_tracerCarrier"
						strokeLinecap="round"
						strokeLinejoin="round"
						stroke="#CCCCCC"
						strokeWidth="1.024"
					/>
					<g id="SVGRepo_iconCarrier">
						{" "}
						<g>
							{" "}
							<g>
								{" "}
								<path d="M502.154,181.778H384c-4.026,0-7.646,2.644-9.142,6.382l-27.714,69.383l-22.474-97.334 c-1.035-4.489-5.012-7.62-9.65-7.608c-4.606,0.026-8.578,3.255-9.563,7.754l-55.187,252.293l-33.694-379.05 c-0.398-4.471-3.767-8.105-8.192-8.84c-4.432-0.729-8.791,1.422-10.613,5.522L121.601,201.47H9.846 c-5.437,0-9.846,4.409-9.846,9.846c0,5.438,4.409,9.846,9.846,9.846H128c3.891,0,7.417-2.098,8.998-5.654l63.33-142.397 l36.018,405.26c0.43,4.844,4.332,8.671,9.184,8.98c0.212,0.013,0.421,0.031,0.63,0.031c4.595,0,8.619-3.192,9.613-7.736 l59.561-272.278l19.688,85.315c0.967,4.193,4.547,7.273,8.838,7.603c4.313,0.334,8.299-2.357,9.898-6.353l36.909-92.464h111.488 c5.438,0,9.846-4.409,9.846-9.846C512,186.187,507.591,181.778,502.154,181.778z" />{" "}
							</g>{" "}
						</g>{" "}
					</g>
				</svg>
				<div className="services-list-card">
					<div className="left-side-service-list">
						<ul>
							<li>Wellness Checkups &amp; Sports Physicals</li>
							<li>Dibetes</li>
							<li>Womens Health</li>
							<li>Muscle/Skeletal</li>
							<li>Smoking Cessation</li>
							<li>Heart Disease</li>
							<li>Dermatology</li>
							<li>Dietary Issues and Nutrition</li>
							<li>Endocrine/Hormonal</li>
						</ul>
					</div>
					<div className="right-side-service-list">
						<ul>
							<li>Allergies</li>
							<li>Gastrointestinal</li>
							<li>
								Mental Health <br />
								(Emotional/Psychological/Social)
							</li>
							<li>Pediatrics</li>
							<li>
								Sick Health <br />
								(Chronic and acute illnesses, minor injuries)
							</li>
							<li>Eye Care</li>
							<li>Free Routine Lab Work</li>
						</ul>
					</div>
				</div>
				<div className="entira-subheading">
					<img src={TeleConnectEntiraLogo} className="teleconnect-logo" />
					<span className="comingsoon-text">
						Call your friends at the Entira Clinic for a virtual appointment today!
					</span>
				</div>
			</div>

			<div className="testonomial-card">
				<figure className="snip1192">
					<div className="author">
						<img src={person1} alt="sq-sample1" loading="lazy" />
						<h5>
							David Feachen <span>CEO / PRESEDIENT</span>
						</h5>
					</div>
				</figure>
				<figure className="snip1192 hover">
					<div className="author">
						<img src={person2} alt="sq-sample24" className="maggie-img" loading="lazy" />
						<h5>
							Maggie Pena<span>Office Coordinator</span>
						</h5>
					</div>
				</figure>
				<figure className="snip1192">
					<div className="author">
						<img src={person3} alt="sq-sample29" loading="lazy" />
						<h5>
							Katherine Diggs
							<span>
								MSN, BSN, ASPRN-C <br /> Women&rsquo;s Health Specialist
							</span>
						</h5>
					</div>
				</figure>
				<figure className="snip1192">
					<div className="author">
						<img src={person4} alt="sq-sample29" loading="lazy" />
						<h5>
							Netha Thompson,
							<span>
								FNP <br />
								Nurse Practitioner
							</span>
						</h5>
					</div>
				</figure>
				<figure className="snip1192">
					<div className="author">
						<img src={person5} alt="sq-sample29" loading="lazy" />
						<h5>
							Dr,Rick Martin,
							<span>
								D.O, FAAFP <br /> Medical Director
							</span>
						</h5>
					</div>
				</figure>
				<figure className="snip1192">
					<div className="author">
						<img src={person6} alt="sq-sample29" loading="lazy" />
						<h5>
							Amy Wright,
							<span>
								RDN, LD, CDE <br />
								Registered Dietitian
							</span>
						</h5>
					</div>
				</figure>
			</div>
		</div>
	);
};

export default ClinicCard;
